<template>
  <div style="width: 20rem">
    <div>
      <input type="text" placeholder="Search" class="search-input" v-model="modelValue" />
    </div>
    <div
      style="
        margin-top: 0.5em;
        height: calc(100vh - 17.5rem);
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 0.2rem;
        overflow: auto;
      "
    >
      <div v-if="loading">
        <div class="message-content">
          <img alt="Data loading" src="@/assets/img/snake_logo_animation_200.gif" style="width: 5rem" />
        </div>
      </div>
      <div v-else v-for="chat in chatList" :key="chat.chat_id" class="chat-button" @click="setCurrentChat(chat)">
        {{ chat.name }}
        <button class="btn-icon" @click.stop="deleteChat(chat.chat_id)">
          <font-awesome-icon icon="trash"></font-awesome-icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Chat } from "@/types/copilot";
interface Props {
  chatList: Chat[];
  setCurrentChat: (chat: Chat) => void;
  deleteChat: (chatId: number) => Promise<void>;
  loading: boolean;
}
const modelValue = defineModel<string>();
const props = defineProps<Props>();
</script>

<style lang="css" scoped>
.search-input {
  margin: 0;
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #ddd;
  font-size: 16px;
  resize: none;
  overflow: auto;
  scrollbar-width: none;
  height: auto;
  max-height: 20vh;
}

.search-input:focus {
  outline: 0;
}
.chat-button {
  border: none;
  padding: 10px;
  border-radius: 5px;
  margin-left: 2px;
  margin-right: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: left;
  background-color: white;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.chat-button:hover {
  background-color: #f0f0f0;
}
</style>
